module.exports = __webpack_public_path__ + "static/img/4.7aebdaa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/3/1/sp/4.png
// module id = VO6E
// module chunks = 0